module.exports = fox._r("images/logos/img-6.gif", __webpack_public_path__ + "_/_/_/common/frame/images/logos/img-6.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos/img-6.gif
// module id = 320
// module chunks = 2